import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import "./AdminShared.css";
import { API_BASE_URL } from "../config";

export default function AdminFranchise() {
  const navigate = useNavigate();
  const [franchises, setFranchises] = useState([]);
  const [loading, setLoading] = useState(true);

  const stored = JSON.parse(localStorage.getItem("adminInfo") || "null");
  const token = stored?.token;

  const fetchFranchises = useCallback(async () => {
    try {
      const res = await fetch(`${API_BASE_URL}/api/admin/franchise`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      setFranchises(Array.isArray(data) ? data.reverse() : []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    if (!token) return navigate("/admin");
    fetchFranchises();
  }, [fetchFranchises, navigate, token]);

  const updateStatus = async (id, status) => {
    if (!window.confirm(`Transition lead to ${status}?`)) return;
    await fetch(`${API_BASE_URL}/api/admin/franchise/${id}/status`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ status }),
    });
    fetchFranchises();
  };

  const deleteFranchise = async (id) => {
    if (!window.confirm("Purge franchise record?")) return;
    await fetch(`${API_BASE_URL}/api/admin/franchise/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    });
    fetchFranchises();
  };

  if (loading) return <div className="admin-list-container"><p style={{padding: '100px', textAlign: 'center'}}>⏳ Synchronizing Franchise Pipeline...</p></div>;

  return (
    <div className="admin-list-container">
      <header className="admin-list-header">
        <div className="header-left-group">
          <button className="admin-back-btn" onClick={() => navigate("/admin/panel")}>←</button>
          <img src="/logo.png" alt="FlyTutor" className="admin-header-logo" />
          <h1 className="admin-header-title">Franchise Expansion</h1>
        </div>
        <button className="module-badge" style={{ cursor: 'pointer', background: '#0f172a', border: 'none' }} onClick={fetchFranchises}>
          Refresh Pipeline 🔄
        </button>
      </header>

      <div className="admin-list-content">
        <div className="admin-info-bar">
          <div className="admin-user-tag">
            <div className="dot" style={{ background: '#0f172a' }}></div>
            Operator: Network Development Node
          </div>
          <div className="admin-status-badge" style={{ background: '#f1f5f9', color: '#334155', fontSize: '0.75rem', fontWeight: 800 }}>
             {franchises.length} REGISTERED INQUIRIES
          </div>
        </div>

        <div className="admin-table-wrapper">
          <table className="elite-table">
            <thead>
              <tr>
                <th>Applicant</th>
                <th>Target Locality</th>
                <th>Capital Provision</th>
                <th>Workflow Status</th>
                <th>Temporal Node</th>
                <th>Operations</th>
              </tr>
            </thead>
            <tbody>
              {franchises.length === 0 ? (
                <tr>
                   <td colSpan="6" style={{ textAlign: 'center', padding: '100px', color: '#94a3b8' }}>
                        No franchise applications detected in the current buffer.
                   </td>
                </tr>
              ) : (
                franchises.map((f) => (
                  <tr key={f._id}>
                    <td>
                      <div style={{ fontWeight: 700 }}>{f.name}</div>
                      <div style={{ fontSize: '0.8rem', color: '#64748b' }}>{f.email}</div>
                      <div style={{ fontSize: '0.8rem', color: '#64748b' }}>{f.phone}</div>
                    </td>
                    <td>
                        <div style={{ fontWeight: 600 }}>{f.city || "N/A"}</div>
                        <div style={{ fontSize: '0.75rem', color: '#94a3b8' }}>REGION-NODE</div>
                    </td>
                    <td>
                        <div style={{ fontWeight: 700, color: '#0f172a' }}>{f.investment}</div>
                        <div style={{ fontSize: '0.75rem', color: '#64748b' }}>INVESTMENT TIER</div>
                    </td>
                    <td>
                        <span className={`status-tag status-${(f.status || 'pending').toLowerCase()}`}>
                            {(f.status || 'PENDING').toUpperCase()}
                        </span>
                    </td>
                    <td>
                        <div style={{ fontWeight: 600 }}>{new Date(f.createdAt).toLocaleDateString()}</div>
                        <div style={{ fontSize: '0.8rem', color: '#94a3b8' }}>{new Date(f.createdAt).toLocaleTimeString()}</div>
                    </td>
                    <td>
                      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                        <button className="action-btn-elite btn-update" style={{ background: '#f1f5f9', color: '#475569' }} onClick={() => updateStatus(f._id, "Contacted")}>CONTACTED</button>
                        <button className="action-btn-elite" style={{ background: '#d1fae5', color: '#065f46' }} onClick={() => updateStatus(f._id, "Approved")}>APPROVE</button>
                        <button className="action-btn-elite" style={{ background: '#fee2e2', color: '#991b1b' }} onClick={() => updateStatus(f._id, "Rejected")}>REJECT</button>
                        <button className="action-btn-elite btn-delete" onClick={() => deleteFranchise(f._id)}><span>🗑️</span></button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
